import React from 'react';
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

type ButtonProps = Omit<MuiButtonProps, 'css'>;

const StyledButton = styled(MuiButton)<ButtonProps>(({ theme }) => ({
  textTransform: 'none',
}));

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    return <StyledButton ref={ref} {...props} />;
  },
);

Button.displayName = 'Button';

export default Button;
